import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AnalysisSessionCard = ({ session, onView, onDelete, getScoreColor }) => {
  const [isHovered, setIsHovered] = useState(false);

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatTime = (dateString) => {
    return new Date(dateString)?.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div
      className="bg-card rounded-xl border border-border overflow-hidden transition-smooth hover:shadow-warm-md cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onView(session?.id)}
    >
      <div className="relative aspect-[16/9] bg-muted overflow-hidden">
        <div className="grid grid-cols-3 gap-1 h-full p-2">
          {session?.thumbnails?.slice(0, 3)?.map((thumb, index) => (
            <div key={index} className="relative rounded-lg overflow-hidden">
              <Image
                src={thumb?.image}
                alt={thumb?.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
        
        <div
          className={`absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent transition-smooth ${isHovered ? 'opacity-100' : 'opacity-0'}`}
        />
        
        <div
          className={`absolute bottom-3 left-3 right-3 flex items-center justify-between transition-smooth ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`}
        >
          <Button
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e?.stopPropagation();
              onView(session?.id);
            }}
            iconName="Eye"
            className="text-white hover:bg-white/20"
          >
            View
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e?.stopPropagation();
              onDelete(session?.id);
            }}
            iconName="Trash2"
            className="text-white hover:bg-white/20"
          />
        </div>
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <Icon name="Calendar" size={14} color="var(--color-muted-foreground)" />
              <span className="text-sm font-medium text-foreground">
                {formatDate(session?.date)}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
              <span className="text-xs text-muted-foreground caption">
                {formatTime(session?.date)}
              </span>
            </div>
          </div>
          
          <div
            className="w-14 h-14 rounded-xl flex items-center justify-center text-xl font-bold flex-shrink-0"
            style={{
              backgroundColor: `${getScoreColor(session?.averageScore)}20`,
              color: getScoreColor(session?.averageScore)
            }}
          >
            {session?.averageScore?.toFixed(1)}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 pt-3 border-t border-border">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
              <Icon name="Image" size={14} color="#9333EA" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-xs text-muted-foreground caption">Photos</div>
              <div className="text-sm font-semibold text-foreground data-text">
                {session?.photoCount}
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center flex-shrink-0">
              <Icon name="TrendingUp" size={14} color="#10B981" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-xs text-muted-foreground caption">Highest</div>
              <div
                className="text-sm font-semibold data-text"
                style={{ color: getScoreColor(session?.highestScore) }}
              >
                {session?.highestScore?.toFixed(1)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisSessionCard;